<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Maintenance',
  computed: {
    ...mapGetters([
      'translate',
      'lang'
    ])
  }
}
</script>
<template>
  <div class="maintenance">
    <h1 v-html="translate['maintenance_title'][lang]"></h1>
    <p>{{ translate['maintenance'][lang] }}</p>
  </div>
</template>
<style scoped>
.maintenance {
  text-align: center;
  margin-top: 3rem;
  padding: 0 1.5rem;
}
.maintenance h1 {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Maintenance.vue